import { graphql } from '../__generated__/gql';

export const GET_ALL_LIFTPLANS = graphql(/* GraphQL */ `
  query LiftPlans($assetId: Int!) {
    allLiftPlans(assetId: $assetId) {
      liftPlanId
      assetId
      planNumber
      description
      type
      equipmentStatus
      structuralAssessment
      safeWorking
      erectHours
      deconstructHours
      oversideCover
      status
      comments
      updatedAt
      updatedBy
      tarJobs {
        jobId
      }
    }
  }
`);

export const GET_JOB_LIFTPLANS = graphql(/* GraphQL */ `
  query JobLiftPlans($jobId: Int!) {
    liftPlansByJobId(jobId: $jobId) {
      liftPlanId
      assetId
      planNumber
      description
      type
      equipmentStatus
      structuralAssessment
      safeWorking
      erectHours
      deconstructHours
      oversideCover
      status
      comments
      updatedAt
      updatedBy
      tarJobs {
        jobId
      }
    }
  }
`);

export const CREATE_LIFTPLAN = graphql(/* GraphQL */ `
  mutation CreateLiftPlan($input: LiftPlanInput!) {
    createLiftPlan(input: $input) {
      liftPlanId
    }
  }
`);

export const UPDATE_LIFTPLAN = graphql(/* GraphQL */ `
  mutation UpdateLiftPlan($input: LiftPlanInput!) {
    updateLiftPlan(input: $input) {
      liftPlanId
    }
  }
`);

export const LINK_LIFTPLAN_JOBS = graphql(/* GraphQL */ `
  mutation LinkLiftPlanJobs($liftPlanId: Int!, $jobIds: [Int]!) {
    linkLiftPlanJobs(liftPlanId: $liftPlanId, jobIds: $jobIds) {
      liftPlanId
    }
  }
`);

export const REMOVE_LIFTPLAN = graphql(/* GraphQL */ `
  mutation RemoveLiftPlan($liftPlanId: Int!) {
    removeLiftPlan(liftPlanId: $liftPlanId)
  }
`);
